import { PropAsset } from './PropAsset';

// Campfire - Kamp Ateşi (Canvas2D animated)
export class Campfire extends PropAsset {
  readonly id = 'campfire';
  readonly width = 32;
  readonly height = 40;
  readonly walkable = false;
  readonly collisionRadius = 0.6;

  draw(ctx: CanvasRenderingContext2D, cx: number, cy: number, s: number, _variant?: number): void {
    // Flicker animation: vary flame height over time
    const time = Date.now() * 0.005;
    const flicker = Math.sin(time * 3.7) * 0.08 + Math.sin(time * 7.3) * 0.05;
    const flameScale = 1 + flicker; // ~0.87 to 1.13

    // Stone ring - Taş halka
    ctx.fillStyle = '#5a5a5a';
    for (let i = 0; i < 8; i++) {
      const angle = (i / 8) * Math.PI * 2;
      const rx = cx + Math.cos(angle) * 10 * s;
      const ry = cy - 5 * s + Math.sin(angle) * 5 * s;
      ctx.beginPath();
      ctx.arc(rx, ry, 3 * s, 0, Math.PI * 2);
      ctx.fill();
    }

    // Logs - Odunlar
    ctx.fillStyle = '#4a3a2a';
    ctx.save();
    ctx.translate(cx, cy - 5 * s);
    ctx.rotate(-0.3);
    ctx.fillRect(-10 * s, -2 * s, 20 * s, 4 * s);
    ctx.restore();

    ctx.save();
    ctx.translate(cx, cy - 5 * s);
    ctx.rotate(0.3);
    ctx.fillRect(-10 * s, -2 * s, 20 * s, 4 * s);
    ctx.restore();

    // Fire glow - Ateş parıltısı (pulses with flicker)
    const glowAlpha = 0.25 + flicker * 0.8;
    ctx.fillStyle = `rgba(255,100,0,${glowAlpha})`;
    ctx.beginPath();
    ctx.arc(cx, cy - 12 * s, (15 + flicker * 8) * s, 0, Math.PI * 2);
    ctx.fill();

    // Outer flame - Dış alev (height varies with flicker)
    const outerTop = -30 * flameScale;
    ctx.fillStyle = '#ff4400';
    ctx.beginPath();
    ctx.moveTo(cx, cy + outerTop * s);
    ctx.quadraticCurveTo(cx - 10 * s, cy - 18 * s, cx - 10 * s, cy - 8 * s);
    ctx.quadraticCurveTo(cx, cy - 12 * s, cx + 10 * s, cy - 8 * s);
    ctx.quadraticCurveTo(cx + 10 * s, cy - 18 * s, cx, cy + outerTop * s);
    ctx.fill();

    // Inner flame - İç alev
    const innerTop = -24 * flameScale;
    ctx.fillStyle = '#ffaa00';
    ctx.beginPath();
    ctx.moveTo(cx, cy + innerTop * s);
    ctx.quadraticCurveTo(cx - 6 * s, cy - 15 * s, cx - 6 * s, cy - 8 * s);
    ctx.quadraticCurveTo(cx, cy - 10 * s, cx + 6 * s, cy - 8 * s);
    ctx.quadraticCurveTo(cx + 6 * s, cy - 15 * s, cx, cy + innerTop * s);
    ctx.fill();

    // Core - Çekirdek
    const coreTop = -18 * flameScale;
    ctx.fillStyle = '#ffff66';
    ctx.beginPath();
    ctx.moveTo(cx, cy + coreTop * s);
    ctx.quadraticCurveTo(cx - 3 * s, cy - 12 * s, cx - 3 * s, cy - 8 * s);
    ctx.quadraticCurveTo(cx, cy - 9 * s, cx + 3 * s, cy - 8 * s);
    ctx.quadraticCurveTo(cx + 3 * s, cy - 12 * s, cx, cy + coreTop * s);
    ctx.fill();
  }
}
